var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "basic-container user-page" }, [
    _c(
      "div",
      { staticClass: "user-panel user-left" },
      _vm._l(_vm.tabArr, function (item) {
        return _c(
          "div",
          {
            key: item.name,
            staticClass: "tab-item",
            class: [_vm.tabActive === item.name ? "tab-item-active" : ""],
            on: {
              click: function ($event) {
                return _vm.handleTabChange(item.name)
              },
            },
          },
          [_c("div", [_vm._v(_vm._s(item.label))])]
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "user-panel user-right" },
      [
        _vm.tabActive === "userInfo" ? _c("userinfo-panel") : _vm._e(),
        _vm.tabActive === "resetPwd" ? _c("reset-pwd") : _vm._e(),
        _vm.tabActive === "loginAuth" ? _c("login-auth") : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }